import {C3TodeltPaiKonfig} from "web-ng2/delt/komponenter/c3-todelt-pai/c3-todelt-pai";
import {farge_profil_500_bergen, farge_suksess_300_mørk} from "felles-ng2/fargepalett";

export function pieKonfig(farge: string): C3TodeltPaiKonfig {
    return {
        ikkePåbegyntPieBorderFarge: farge,
        ikkePåbegyntFarge: '#ffffff00', // transparent farge gir riktig hover-effekt inni md-button
        restFarge: '#ffffff00', // transparent farge gir riktig hover-effekt inni md-button
        andelFarge: farge,
        fullførtFarge: farge,
        interaksjonAktivert: false,
        termineringsTimeout: 500
    };
}

export const pieKonfigBlaa = pieKonfig(farge_profil_500_bergen); //samme som $std-farge-tekst-lenke i _definisjoner.scss
export const pieKonfigGroenn = pieKonfig(farge_suksess_300_mørk); //samme som $farge-tekst--ok i definisjoner.scss
